import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { message } from "antd";
import { IoIosArrowBack } from "react-icons/io";

const ViewStandard = ({ show, handleClose, agentData, fetchData }) => {
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");

  useEffect(() => {
    if (agentData) {
      setName(agentData.standardName || "");
      setDescription(agentData.description || "");
    }
  }, [agentData]);

  const handleBackButton = () => {
    handleClose();
  };

  return (
    <Modal
      show={show}
      onHide={handleClose}
      size="lg"
      centered
      backdrop="static"
      dialogClassName="custom-agent-modal"
    >
      <Modal.Header closeButton>
        <Modal.Title>Edit Standard</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <form>
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-12 mb-3">
                <label className="form-label">Standard Name</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter Vendor name"
                  value={name}
                  readOnly
                />
              </div>

              <div className="col-md-12 mb-3">
                <label className="form-label">Description</label>
                <input
                  type="email"
                  className="form-control"
                  placeholder="Enter email"
                  value={description}
                   readOnly
                />
              </div>
            </div>

            <div className="d-flex justify-content-end gap-2 mt-2">
              <button
                className="agents-back-button"
                onClick={handleBackButton}
                type="button"
              >
                <IoIosArrowBack /> Back
              </button>
            </div>
          </div>
        </form>
      </Modal.Body>
    </Modal>
  );
};

export default ViewStandard;
